import React, { useEffect, useState } from "react";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import {
  Button,
  TextField,
  Autocomplete,
  Grid,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  DialogContentText,
  DialogTitle,
  Divider,
} from "@mui/material";
import AWS from "aws-sdk";
import { useNavigate } from "react-router";
import { TableCustom } from "./table";
import "./fileuploader.scss";
import { ToastContainer, toast } from "react-toastify";
import { Spinner } from "react-bootstrap";
import { API } from "../../constants/APIConstant";
import {
  InvokeGetServiceCall,
  InvokePostServiceCall,
  server_path,
} from "../../api/apiServices";
import MainContainer from "../main-container/MainContainer";
import { Language_Models } from "../../constants/AppConstant";

const REGION = "us-east-1";

AWS.config.update({
  region: REGION,
});

const Folderupload = ({ setIsLoggedIn, userName }) => {
  const navigate = useNavigate();
  const notify = () => toast.error("Something went wrong!");

  const initialState = {
    isSidebarOpen: true,
    tableData: [],
    spinnerLoading: false,
    text: "",
    isModalOpen: false,
    files: [],
    rowClick: false,
    titleName: "",
    chunkSize: "Small-100",
    overLapping: "Small-20",
    process: true,
    openShareDialog: false,
    chatData: {
      token: "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",
      model: "meta-llama/Llama-2-13b-chat-hf",
      vectorstore: "pdf",
      maxtokens: 1024,
      temp: 0.2,
      top_p: 0.95,
      repetition_penaulty: 1.15,
      quantization: 4,
    },
    uploading: false,
  };

  const [state, setState] = useState(initialState);
  const [modalBtnLoading, setModalBtnLoading] = useState(false);
  const [configurationLoading, setConfigurationLoading] = useState(false);
  const [configurationData, setConfigurationData] = useState({
    language_model: "",
    max_tokens: "",
    temperature: "",
    top_p: "None",
    repetition_penalty: "None",
    system_prompt: "",
    k: "",
  });
  const [shareUserName, setShareUserName] = useState("");
  const [folderNames, setFolderNames] = useState([]);
  const [infoLoading, setInfoLoading] = useState(false);
  const [projectInfo, setProjectInfo] = useState([]);
  const [openInfoDialog, setOpenInfoDialog] = useState(false);

  const handleFileSelect = (acceptedFiles) => {
    setState((prevState) => ({
      ...prevState,
      files: acceptedFiles.target.files,
    }));
  };

  const handleLogOut = () => {
    navigate("/");
    setIsLoggedIn(false);
    sessionStorage.clear("accesstoken");
    sessionStorage.clear("userName");
  };

  const handleCreate = () => {
    handleModalOpen("create");
  };

  const handleModalOpen = (dialogName) => {
    setState((prevState) => ({ ...prevState, isModalOpen: dialogName }));
  };

  const handleModalClose = () => {
    setState((prevState) => ({
      ...prevState,
      isModalOpen: false,
      files: [],
      text: "",
    }));
  };

  const handleTextChange = (e) => {
    setState((prevState) => ({ ...prevState, text: e.target.value }));
  };

  const handleUpload = () => {
    setState((prevState) => ({ ...prevState, uploading: true }));
    for (let i = 0; i < folderNames.length; i++) {
      if (state.text === folderNames[i]) {
        const notify = () =>
          toast.error("Project with same name already exists.");
        notify();
        handleModalClose();
        setState((prevState) => ({ ...prevState, uploading: false }));
        return;
      }
    }
    for (let i = 0; i < state.tableData.length; i++) {
      if (state.text === state.tableData[i].project_id) {
        const notify = () =>
          toast.error("Project with same name already exists.");
        notify();
        handleModalClose();
        setState((prevState) => ({ ...prevState, uploading: false }));
        return;
      }
    }
    uploadFile(state.files);
  };

  const handleProcess = (project_id) => {
    handleModalOpen("process");
    setState((prevState) => ({ ...prevState, titleName: project_id }));
  };

  const handleConfiguration = (project_id) => {
    setConfigurationLoading(true);
    handleModalOpen("configure");
    setState((prevState) => ({ ...prevState, titleName: project_id }));

    setConfigurationData({
      language_model: "",
      max_tokens: "",
      temperature: "",
      top_p: "None",
      repetition_penalty: "None",
      system_prompt: "",
      k: "",
    });

    let requestBody = {
      project_id: project_id,
    };
    InvokePostServiceCall(API.get_configuration, requestBody)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        let temperature = "" + res[0].temperature;
        if (temperature.includes("0.1")) {
          temperature += " (Precise)";
        } else if (temperature.includes("0.5")) {
          temperature += " (Balanced)";
        } else if (temperature.includes("0.7")) {
          temperature += " (Creative)";
        } else if (temperature.includes("1.0")) {
          temperature += " (Inventive)";
        }

        let tempLanguageModel = "";
        for (let i = 0; i < Language_Models.length; i++) {
          if (Language_Models[i].value === res[0].language_model) {
            tempLanguageModel = {
              title: Language_Models[i].title,
              value: Language_Models[i].value,
            };
            break;
          }
        }
        setConfigurationData({
          language_model: tempLanguageModel,
          max_tokens: res[0].max_tokens,
          temperature: temperature,
          top_p: res[0].top_p,
          repetition_penalty: res[0].repetition_penalty,
          system_prompt: res[0].system_prompt,
          k: res[0].k,
        });
        setConfigurationLoading(false);
      })
      .catch((error) => {
        console.log(error);
        notify();
        setConfigurationLoading(false);
      });
  };

  const handleEVR = (project_id) => {
    setState((prevState) => ({
      ...prevState,
      process: false,
      rowClick: true,
      titleName: project_id,
    }));
    navigate("/chat", {
      state: {
        selectedTab: "Draft Evidence Report Generator",
        projectId: project_id,
      },
    });
  };

  const handleSaveConfiguration = (configurationRequestBody = "") => {
    setModalBtnLoading(true);
    let requestBody;
    if (configurationRequestBody !== "") {
      requestBody = configurationRequestBody;
    } else {
      requestBody = {
        project_name: state.titleName,
        language_model: configurationData.language_model.value,
        max_tokens: configurationData.max_tokens,
        temperature: configurationData.temperature.split(" ")[0],
        // top_p: configurationData.top_p,
        top_p: "None",
        // repetition_penalty: configurationData.repetition_penalty,
        repetition_penalty: "None",
        system_prompt: configurationData.system_prompt,
        k: configurationData.k,
        // k: "None",
      };
    }

    InvokePostServiceCall(API.model_parameters, requestBody)
      .then((response) => response.text())
      .then((result) => {
        setModalBtnLoading(false);
        if (!configurationRequestBody) {
          const notify = () => toast.success("Saved Sucessfully!");
          notify();
        }
        handleModalClose();
      })
      .catch((error) => {
        console.error(error);
        notify();
        setModalBtnLoading(false);
      });
  };

  async function uploadFile(files) {
    const backendUrl = `${server_path}${API.features_generate_presigned_url}`;
    let uploadFailed = false;
    try {
      for (const file of files) {
        let requestBody = {
          fileName: file.name,
          projectName: state.text,
          userName: userName,
        };
        const options1 = {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
          redirect: "follow",
        };

        const response = await fetch(backendUrl, options1);
        const data = await response.json();
        const signedUrl = data.url;

        const options = {
          method: "PUT",
          headers: {
            "Content-Type": "application/pdf",
            // "Content-Disposition": `attachment; filename="${file.name}"`,
          },
          body: file,
        };

        const uploadResponse = await fetch(signedUrl, options);

        if (!uploadResponse.ok) {
          uploadFailed = true; // Mark upload as failed
          break; // Exit loop if any upload fails
        }
      }

      if (!uploadFailed && files.length > 0) {
        const notifyAll = () => toast.success("All files uploaded");
        notifyAll();
        handleModalClose();
        getTableData();

        let requestBody = {
          project_name: state.text,
        };

        InvokePostServiceCall(API.features_public_doc, requestBody)
          .then((response) => response.text())
          .then((result) => console.log(result))
          .catch((error) => console.error(error));

        let configurationRequestBody = {
          project_name: state.text,
          // language_model: "None",
          language_model: "meta.llama3-1-405b-instruct-v1:0",
          max_tokens: "None",
          temperature: "None",
          top_p: "None",
          repetition_penalty: "None",
          system_prompt: "None",
          // k: "None",
          k: "2",
        };
        handleSaveConfiguration(configurationRequestBody);
      }
    } catch (error) {
      console.log(error, "error message");
      const notify = () => toast.error("Upload Failed");
      notify();
      handleModalClose();
    } finally {
      setState((prevState) => ({ ...prevState, uploading: false }));
    }
  }

  const startProcess = () => {
    handleModalClose();
    proccessAPi();
  };

  const proccessAPi = () => {
    for (let i = 0; i < state.tableData.length; i++) {
      if (state.tableData[i].project_id === state.titleName) {
        let tableData = [...state.tableData];
        tableData[i].status = "In Process";
        setState((prev) => ({ ...prev, tableData: tableData }));
        break;
      }
    }

    let requestBody = {
      dbstore: "FAISS-ParentRetriever",
      knowledge_base: state.titleName,
      chunk_size: parseInt(state.chunkSize.split("-")[1], 10),
      overlap: parseInt(state.overLapping.split("-")[1], 10),
    };

    InvokePostServiceCall(API.create_vectorstore, requestBody)
      .then((response) => response.text())
      .then((result) => {
        let res = JSON.parse(result);
        if (res.status === "success") {
          const notify = () => toast.success(res.message);
          notify();
        } else if (res.status === "error") {
          for (let i = 0; i < state.tableData.length; i++) {
            if (state.tableData[i].project_id === state.titleName) {
              let tableData = [...state.tableData];
              tableData[i].status = "Failed";
              setState((prev) => ({ ...prev, tableData: tableData }));
              break;
            }
          }
          const notify = () =>
            toast.error(`${state.titleName} - ${res.message}`);
          notify();
        }
      })
      .catch((error) => {
        notify();
        console.error(error);
      });
  };

  const getTableData = () => {
    setState((prevState) => ({ ...prevState, spinnerLoading: true }));
    // InvokeGetServiceCall(API.GET_TABLE)
    InvokePostServiceCall(API.features_get_table, { user_id: userName })
      .then((response) => response.json())
      .then((result) => {
        result.forEach((item) => {
          item.processPercentage = 0;
        });
        setState((prevState) => ({
          ...prevState,
          tableData: result,
          spinnerLoading: false,
        }));
      })
      .catch(() => {
        setState((prevState) => ({ ...prevState, spinnerLoading: false }));
        notify();
      });
  };

  const getFolderNames = async () => {
    try {
      let response = await InvokeGetServiceCall(API.features_get_folder_name);
      let result = await response.json();
      setFolderNames(result?.projects);
    } catch (error) {
      console.log(error, "getFolderNames Error message");
      notify();
    }
  };

  const handleDelete = (project, handleCloseDeleteDialog) => {
    const notifyDelete = () => toast.success("Deleted project");

    let requestBody = {
      project_name: project,
    };

    InvokePostServiceCall(API.features_delete, requestBody)
      .then((response) => response.text())
      .then(() => {
        handleCloseDeleteDialog();
        notifyDelete();
        getTableData();
      })
      .catch(() => notify());
  };

  useEffect(() => {
    getFolderNames();
    getTableData();
  }, []);

  const processDialogContent = (
    <>
      <div style={styles.dialogContentDiv}>
        <Button variant="contained" color="warning" onClick={handleModalClose}>
          &#10005;
        </Button>
      </div>
      <DialogContent sx={{ paddingTop: "10px" }}>
        <TextField
          label="Project Name"
          type="text"
          defaultValue={state.titleName}
          sx={{ width: "40%", marginBottom: 10 }}
        />
        <Grid container spacing={2}>
          <Grid item xs={12} md={4}>
            <TextField
              label="Vector Database"
              type="text"
              defaultValue={"FAISS"}
              sx={{ width: "100%" }}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              value={state.chunkSize}
              onChange={(event, newValue) =>
                setState((prevState) => ({
                  ...prevState,
                  chunkSize: newValue,
                }))
              }
              options={["Small-100", "Medium-300", "Large-500"]}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Document Segment Size (Tokens)"
                  sx={{ marginBottom: 2 }}
                />
              )}
            />
          </Grid>
          <Grid item xs={12} md={4}>
            <Autocomplete
              value={state.overLapping}
              onChange={(event, newValue) =>
                setState((prevState) => ({
                  ...prevState,
                  overLapping: newValue,
                }))
              }
              options={["Small-20", "Medium-30", "Large-50"]}
              sx={{ width: "100%" }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Overlap Between Segment (Tokens)"
                  sx={{ marginBottom: 2 }}
                />
              )}
            />
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions sx={styles.dialogActions}>
        <Button variant="contained" onClick={startProcess} sx={styles.saveBtn}>
          Process
        </Button>
      </DialogActions>
    </>
  );

  const configureDialogContent = (
    <>
      <div style={styles.dialogContentDiv}>
        <Button variant="contained" color="warning" onClick={handleModalClose}>
          &#10005;
        </Button>
      </div>

      <DialogContent sx={{ paddingTop: "10px" }}>
        {configurationLoading ? (
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              height: 282,
            }}
          >
            <Spinner />
          </div>
        ) : (
          <>
            <TextField
              label="Project Name"
              type="text"
              inputProps={{ readOnly: true }}
              defaultValue={state.titleName}
              sx={{
                marginBottom: 10,
                width: "40%",
              }}
            />
            <Grid container spacing={2}>
              {/* <Grid item xs={12} md={3.5}>
                <Autocomplete
                  value={configurationData.language_model}
                  onChange={(event, newValue) => {
                    if (
                      newValue?.value?.includes("llama") ||
                      newValue?.value?.includes("Llama")
                    ) {
                      setConfigurationData({
                        ...configurationData,
                        language_model: newValue,
                        k: "2",
                      });
                    } else if (newValue?.value === "gpt-3.5-turbo") {
                      setConfigurationData({
                        ...configurationData,
                        language_model: newValue,
                        k: "8",
                      });
                    } else {
                      setConfigurationData({
                        ...configurationData,
                        language_model: newValue,
                        k: "10",
                      });
                    }
                  }}
                  options={Language_Models}
                  getOptionLabel={(option) => option.title}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Language Model *"
                      sx={{ marginBottom: 2 }}
                    />
                  )}
                />
              </Grid> */}
              <Grid item xs={12} md={4}>
                <Autocomplete
                  value={configurationData.max_tokens}
                  onChange={(event, newValue) => {
                    setConfigurationData({
                      ...configurationData,
                      max_tokens: newValue,
                    });
                  }}
                  options={["100", "500", "1000", "4096"]}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Generated Output Length (Tokens) *"
                      sx={{ marginBottom: 2 }}
                    />
                  )}
                />
              </Grid>
              <Grid item xs={12} md={4}>
                <Autocomplete
                  value={configurationData.temperature}
                  onChange={(event, newValue) => {
                    setConfigurationData({
                      ...configurationData,
                      temperature: newValue,
                    });
                  }}
                  options={[
                    "0.1 (Precise)",
                    "0.2",
                    "0.3",
                    "0.4",
                    "0.5 (Balanced)",
                    "0.6",
                    "0.7 (Creative)",
                    "0.8",
                    "0.9",
                    "1.0 (Inventive)",
                  ]}
                  sx={{ width: "100%" }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Temperature *"
                      sx={{ marginBottom: 2 }}
                    />
                  )}
                />
              </Grid>

              <Grid item xs={12} md={4}>
                <Autocomplete
                  value={configurationData.k}
                  onChange={(event, newValue) => {
                    setConfigurationData({
                      ...configurationData,
                      k: newValue,
                    });
                  }}
                  sx={{ width: "100%" }}
                  options={[
                    "1",
                    "2",
                    "3",
                    "4",
                    "5",
                    "6",
                    "8",
                    "10",
                    "15",
                    "20",
                    "25",
                    "30",
                    "35",
                    "45",
                    "50",
                  ].filter((item) =>
                    configurationData.language_model?.value?.includes(
                      "llama"
                    ) ||
                    configurationData.language_model?.value?.includes("Llama")
                      ? parseInt(item) < 3
                      : configurationData.language_model?.value ===
                        "gpt-3.5-turbo"
                      ? parseInt(item) > 2 && parseInt(item) < 9
                      : configurationData.language_model?.value ===
                          "mistral.mistral-7b-instruct-v0:2" ||
                        configurationData.language_model?.value ===
                          "mistral.mixtral-8x7b-instruct-v0:1" ||
                        configurationData.language_model?.value ===
                          "mistral.mistral-large-2402-v1:0"
                      ? parseInt(item) < 11
                      : item
                  )}
                  renderInput={(params) => (
                    <TextField {...params} label="Search kwargs" />
                  )}
                />
              </Grid>
            </Grid>
            <TextField
              variant="outlined"
              label="System Prompt *"
              value={configurationData.system_prompt}
              multiline
              maxRows={2}
              inputProps={{ maxLength: 512 }}
              sx={{ width: "100%" }}
              onChange={(e) => {
                setConfigurationData({
                  ...configurationData,
                  system_prompt: e.target.value,
                });
              }}
            />
            <div
              style={styles.charLimitText}
            >{`${configurationData.system_prompt?.length}/512`}</div>
          </>
        )}
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="contained"
          onClick={() => {
            handleSaveConfiguration();
          }}
          disabled={
            !configurationData.language_model ||
            !configurationData.max_tokens ||
            !configurationData.system_prompt ||
            !configurationData.temperature
          }
          sx={styles.saveBtn}
        >
          Save
          {modalBtnLoading ? <Spinner size="sm" className="ml-2" /> : <></>}
        </Button>
      </DialogActions>
    </>
  );

  const createDialogContent = (
    <>
      <div style={styles.dialogContentDiv}>
        <Button variant="contained" color="warning" onClick={handleModalClose}>
          &#10005;
        </Button>
      </div>

      <DialogContent sx={{ paddingTop: "10px" }}>
        <TextField
          label="Project name"
          type="text"
          sx={{ width: "30%" }}
          onChange={handleTextChange}
        />
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <p>Please select folder from below</p>
          <label htmlFor="folder-input">
            <IconButton component="span">
              <CloudUploadIcon style={{ width: "100px", height: "100px" }} />
            </IconButton>
            <input
              id="folder-input"
              style={{ display: "none" }}
              directory=""
              webkitdirectory=""
              type="file"
              onChange={handleFileSelect}
            />
          </label>
        </div>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          {state.files?.length > 0 && `Selected files: ${state.files.length}`}
        </div>
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="contained"
          disableElevation={
            !state.text || state.uploading || !state.files.length
          }
          sx={{
            cursor:
              state.text && !state.uploading && state.files.length
                ? "pointer"
                : "not-allowed !important",
            ...styles.saveBtn,
          }}
          onClick={handleUpload}
          title={state.text ? "" : "Please enter project name and select file"}
        >
          Create {state.uploading && <Spinner size="sm" className="ml-2" />}
        </Button>
      </DialogActions>
    </>
  );

  const handleShare = (project_id) => {
    setShareUserName("");
    handleModalOpen("share");
    setState((prevState) => ({ ...prevState, titleName: project_id }));
  };

  const handleShareProjectDetails = () => {
    setModalBtnLoading(true);
    let requestBody = {
      user_id: shareUserName.split("@")[0],
      project_name: state.titleName,
    };
    InvokePostServiceCall(API.features_save_project_access, requestBody)
      .then((response) => response.text())
      .then((result) => {
        setModalBtnLoading(false);
        const notify = () => toast.success("Shared Successfully!");
        notify();
        handleModalClose();
      })
      .catch((error) => {
        console.log(error, "Error Message");
        setModalBtnLoading(false);
        const notify = () => toast.error("Something went wrong!");
        notify();
      });
  };

  const handleOpenInfoDialog = () => {
    setOpenInfoDialog(true);
  };

  const handleCloseInfoDialog = () => {
    setOpenInfoDialog(false);
    setProjectInfo([]);
  };

  const handleInfo = (projectName) => {
    setInfoLoading(true);
    handleOpenInfoDialog();

    let requestBody = {
      project_name: projectName,
    };

    InvokePostServiceCall(API.features_get_project_files, requestBody)
      .then((response) => response.text())
      .then((result) => {
        setProjectInfo(JSON.parse(result));
        setInfoLoading(false);
      })
      .catch((error) => {
        console.error(error);
        notify();
        setInfoLoading(false);
      });
  };

  const shareDialogContent = (
    <>
      <div style={styles.dialogContentDiv}>
        <Button variant="contained" color="warning" onClick={handleModalClose}>
          &#10005;
        </Button>
      </div>
      <DialogContent sx={{ paddingTop: "10px" }}>
        <TextField
          label="Project Name"
          type="text"
          inputProps={{ readOnly: true }}
          defaultValue={state.titleName}
          sx={{
            marginBottom: "24px",
            width: "40%",
          }}
        />
        <TextField
          label="Username"
          type="text"
          value={shareUserName}
          sx={{
            width: "100%",
          }}
          onChange={(e) => {
            setShareUserName(e.target.value);
          }}
        />
      </DialogContent>
      <DialogActions sx={styles.dialogActions}>
        <Button
          variant="contained"
          onClick={() => {
            handleShareProjectDetails();
          }}
          disabled={!shareUserName.length}
          sx={styles.saveBtn}
        >
          Share
          {modalBtnLoading ? <Spinner size="sm" className="ml-2" /> : <></>}
        </Button>
      </DialogActions>
    </>
  );

  return (
    <>
      <MainContainer
        handleCreate={handleCreate}
        handleLogOut={handleLogOut}
        showCreateButton={true}
      >
        <h3>Chat/Report Generation</h3>
        <ToastContainer />
        {state.tableData.length > 0 || !state?.spinnerLoading ? (
          <TableCustom
            tableData={state.tableData}
            spinnerLoading={state.spinnerLoading}
            setTableData={setState}
            handleConfiguration={handleConfiguration}
            handleProcess={handleProcess}
            handleEVR={handleEVR}
            handleDelete={handleDelete}
            handleShare={handleShare}
            handleInfo={handleInfo}
            showUseButton={true}
            showProcessButton={true}
            showConfigureButton={true}
            showInfoButton={true}
            showShareButton={true}
            showDeleteButton={true}
            showPercentage={true}
          />
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "90vh",
            }}
          >
            <Spinner animation="border" role="status">
              <span className="sr-only">Loading...</span>
            </Spinner>
          </div>
        )}

        <Dialog
          open={state.isModalOpen}
          onClose={handleModalClose}
          fullWidth
          maxWidth="md"
          sx={{ borderRadius: "14px" }}
        >
          {state.isModalOpen === "create" ? (
            createDialogContent
          ) : state.isModalOpen === "process" ? (
            processDialogContent
          ) : state.isModalOpen === "share" ? (
            shareDialogContent
          ) : state.isModalOpen === "configure" ? (
            configureDialogContent
          ) : (
            <></>
          )}
        </Dialog>

        <Dialog
          open={openInfoDialog}
          onClose={handleCloseInfoDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          fullWidth
        >
          <DialogTitle id="alert-dialog-title">
            {"Project Information"}
          </DialogTitle>
          <DialogContent
            sx={{ maxHeight: "59vh", overflowY: "auto", scrollbarWidth: "1px" }}
          >
            {infoLoading && (
              <div style={{ display: "flex", justifyContent: "center" }}>
                <Spinner />
              </div>
            )}
            {!infoLoading && (
              <>
                <h6>Configuration</h6>

                <div style={{ marginBottom: "10px", paddingLeft: "5px" }}>
                  <DialogContentText>
                    Project Name : {projectInfo.rows_dict?.[0]?.project_name}
                  </DialogContentText>
                  <DialogContentText>
                    Language Model :{" "}
                    {projectInfo.rows_dict?.[0]?.language_model}
                  </DialogContentText>
                  <DialogContentText>
                    {`Generated Output Length (Tokens) : ${projectInfo.rows_dict?.[0]?.max_tokens}`}
                  </DialogContentText>
                  <DialogContentText>
                    Search Kwargs : {projectInfo.rows_dict?.[0]?.k}
                  </DialogContentText>
                  <DialogContentText>
                    System Prompt : {projectInfo.rows_dict?.[0]?.system_prompt}
                  </DialogContentText>
                </div>

                <h6>Pdf List</h6>
                {projectInfo.pdf_list?.map((item, index) => {
                  return (
                    <div
                      key={`${index}${item}`}
                      style={{ wordBreak: "break-word", marginBottom: "10px" }}
                    >
                      <DialogContentText
                        sx={{
                          // border:"1px solid #00000099",borderRadius:"10px",
                          padding: "10px",
                        }}
                      >
                        <a href={item}>
                          {item?.split("/")[item?.split("/").length - 1]}
                        </a>
                      </DialogContentText>
                      <Divider sx={{ borderColor: "#00000099" }} />
                    </div>
                  );
                })}
              </>
            )}
            {!infoLoading && projectInfo.length < 1 && (
              <div>No information</div>
            )}
          </DialogContent>
          <DialogActions>
            <Button sx={{ width: "73px" }} onClick={handleCloseInfoDialog}>
              Close
            </Button>
          </DialogActions>
        </Dialog>
      </MainContainer>
    </>
  );
};

export default Folderupload;

const styles = {
  habilisLogo: {
    height: "44px",
    width: "auto",
    borderRadius: "4px",
    backgroundColor: "white",
    paddingLeft: "1.5px",
  },
  charLimitText: {
    fontSize: "12px",
    fontWeight: 600,
    color: "grey",
    marginLeft: "3px",
  },
  saveBtn: {
    height: "45px",
    backgroundColor: "#065f9b",
    "&:hover": {
      backgroundColor: "#065f9b",
      color: "white",
    },
  },
  dialogContentDiv: {
    display: "flex",
    justifyContent: "flex-end",
    margin: "20px 20px 0px 0px",
  },
  dialogActions: {
    paddingRight: "20px",
    paddingBottom: "20px",
  },
};
